module.exports = __webpack_public_path__ + "static/media/sign.40b6ba31.svg";